export const LineItemObj = {
    "isClaimed": 0,
    "isNewUpload": true,
    "line_type": "",
    "line_item_checked": 0,
    "reference_id": "",
    "tariff_code": "",
    "nappi_code": "",
    "description": "",
    "doctor_id": "",
    "quantity": 1,
    "numberOfUnits": 1,
    "base_price": 0,
    "perUnitPrice": 0,
    "price": 0,
    "calculatedPrice": 0,
    "days_of_therapy": 0,
    "diagnosis_code": "",
    "modifierType":"",
    "isPrimary": 0,
    "dispencingQuantity": 0,
    "fixedFeeWithVAT": 0,
    "markupPercent": 0,
    "parentNappiCode": "",
    "parentTariffCode": "",
    "superParentTariffCode": "",
    "childAddition": "",
    "startdatetime":"",
    "enddatetime":"",
    "anestheticUnits": "",
    "anestheticUnitValue": ""
  }

//No modifier applies to these consultation codes
  export const ConsultationCodes = ["0107","0109","0111","0113","0126","0129","0130","0131","0132","0133",
  "0137","0138","0139","0145","0146","0147","0148","0149","0151","0152","0153","0161","0162",
  "0163","0164","0166","0167","0168","0169","0173","0174","0175","0176","0177","0178","0179",
  "0190","0191","0192","0193","0193","0194","0195","0197","0198","0199","0201","0202","7000",
  "7010","7050","7051","7052","7060","7061","7062","7063","7064"];

  export const flateRateConsulations = ["0190","0192"];
  //Package Codes for Medisiwtch. Important for claims
  export const MedSwitchPackageCodes = [{
    test_mode: 1, // test
    package_code: "SWITCHON"
  },{
    test_mode: 0, // Live
    package_code: "TECHTSOC"
  }]